import script from "./TinySlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./TinySlider.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__